import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { apiRequest } from '@/lib/api';
import type { Me, MeResponse } from '@/types/me';

export const ME_QUERY_KEY = ['me'] as const;
const ME_STALE_TIME_MS = 30_000;

/** The authoritative profile and role. Never authorise UI on useAuth().user.role (JWT claim). */
export function useMe(): UseQueryResult<Me> {
  return useQuery({
    queryKey: ME_QUERY_KEY,
    queryFn: async () => (await apiRequest<MeResponse>('/api/me')).user,
    staleTime: ME_STALE_TIME_MS,
    refetchOnWindowFocus: true,
  });
}
